const dynamicCityDropdown = () => {
    const countrySelect = document.getElementById("photographer_country");
    const citySelect = document.getElementById("photographer_city");
    const cityContainer = document.getElementById("city_list")
    const countrySelectMobile = document.getElementById("photographer_country_mobile");
    const citySelectMobile = document.getElementById("photographer_city_mobile");
    // Parse JSON once at init instead of on every change event
    const cityList = cityContainer ? JSON.parse(cityContainer.dataset.list) : [];

    const populateCities = (select, countryId) => {
        select.textContent = "";
        for (let i = 0; i < cityList.length; i++) {
            if (cityList[i].country_id == countryId) {
                const opt = document.createElement("option");
                opt.value = cityList[i].name;
                opt.textContent = cityList[i].name;
                select.appendChild(opt);
            }
        }
    };

    if (countrySelect) {
        countrySelect.addEventListener("change", (event) => {
            populateCities(citySelect, event.currentTarget.value);
            document.getElementById("cityselection_input").classList.remove("hidden");
        })
    }
    if (countrySelectMobile) {
        countrySelectMobile.addEventListener("change", (event) => {
            populateCities(citySelectMobile, event.currentTarget.value);
            document.getElementById("cityselection_input_mobile").classList.remove("hidden");
        })
    }
}  

export { dynamicCityDropdown };